<template>
    <section class="relative  pbm">
    <div class="hero-half container">
        <div class="hero-half-content">
            <div class="hero-title">
                <h1><span>Manchester Met Learning and Teaching Conference 2023</span> Building a Transformational Active Learning Community</h1>
                <div class="hero-title-content narrow-text">
                    <p>The Centre for <b>Learning Enhancement and Educational Development (LEED)</b> are delighted to announce Manchester Met’s annual Learning and Teaching conference.</p>
                    <div class="hero-key-info">
                        <div class="hero-key-info-icon">
                        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 31">
                        <line x1="31" y1="12" x2="1" y2="12" style="fill: none;  stroke-miterlimit: 10; "/>
                        <rect x="1" y="4" width="30" height="26" rx="3" ry="3" style="fill: none;  stroke-linecap: square; stroke-miterlimit: 10; "/>
                        <line x1="8" y1="1" x2="8" y2="7" style="fill: none;  stroke-linecap: square; stroke-miterlimit: 10; "/>
                        <line x1="24" y1="1" x2="24" y2="7" style="fill: none;  stroke-linecap: square; stroke-miterlimit: 10; "/>
                        </svg>
                    </div>
                    <div class="hero-key-info-text">Wednesday 14th June, 9:30am - 4:00pm</div>
                    </div>
                    <div class="hero-key-info">
                        <div class="hero-key-info-icon">
                      <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29 32">
                    <line x1="14" y1="1" x2="14" y2="4" style="fill: none;  stroke-linecap: square; stroke-miterlimit: 10; stroke-width: 2px;"/>
                    <line x1="8" y1="3" x2="8" y2="6" style="fill: none;  stroke-linecap: square; stroke-miterlimit: 10; stroke-width: 2px;"/>
                    <line x1="20" y1="3" x2="20" y2="6" style="fill: none;  stroke-linecap: square; stroke-miterlimit: 10; stroke-width: 2px;"/>
                    <path d="m23,11h5v5c0,1.66-1.34,3-3,3h-2" style="fill: none;  stroke-miterlimit: 10; stroke-width: 2px;"/>
                    <path d="m14,27h0c-4.97,0-9-4.03-9-9v-7h18v7c0,4.97-4.03,9-9,9Z" style="fill: none;  stroke-linecap: square; stroke-miterlimit: 10; stroke-width: 2px;"/>
                    <line x1="1" y1="31" x2="27" y2="31" style="fill: none;  stroke-linecap: square; stroke-miterlimit: 10; stroke-width: 2px;"/>
                    </svg>
                    </div>
                    <div class="hero-key-info-text">Fully catered</div>
                    </div>

                    <div class="hero-key-info">
                        <div class="hero-key-info-icon">
                        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 31">
                        <polygon points="31 1 14 1 14 15 19 11 31 11 31 1" style="fill: none;  stroke-linecap: square; stroke-miterlimit: 10; "/>
                        <circle cx="25" cy="18" r="3" style="fill: none;  stroke-linecap: square; stroke-miterlimit: 10; "/>
                        <circle cx="7" cy="18" r="3" style="fill: none;  stroke-linecap: square; stroke-miterlimit: 10; "/>
                        <path d="m13,30v-2.98c0-.71-.37-1.36-.98-1.73-.97-.58-2.66-1.29-5.02-1.29s-4.06.71-5.03,1.29c-.61.36-.97,1.01-.97,1.72v2.99h12Z" style="fill: none;  stroke-linecap: square; stroke-miterlimit: 10; "/>
                        <path d="m31,30v-2.98c0-.71-.37-1.36-.98-1.73-.97-.58-2.66-1.29-5.02-1.29s-4.06.71-5.03,1.29c-.61.36-.97,1.01-.97,1.72v2.99h12Z" style="fill: none;  stroke-linecap: square; stroke-miterlimit: 10; "/>
                        </svg>
                    </div>
                    <div class="hero-key-info-text">In-person conference</div>
                    </div>
                </div>
                <div class="hero-btns mtt">
                    <q-btn @click="eventHandler" color="primary" label="See programme"  no-caps />
                    <q-btn @click="scrollHandler" outline color="white" text-color="black" label="Learn more" no-caps />
                    <q-btn outline color="white" text-color="black" label="Intro video" no-caps @click="openCloseModal" />
                </div>
            </div>
        </div>
        <div class="hero-half-image">
        </div>
    </div>
    <div class="hero-divider">
            <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
        <path d="M1200 0L0 0 892.25 114.72 1200 0z" class="shape-fill"></path>
    </svg>
    </div>      
    </section>
</template>

<script setup>
    import { useRouter } from "vue-router"

    const router = useRouter()

    const props = defineProps({icon: Boolean})


    
    const emit = defineEmits(['watchVideo']) 
    
    const eventHandler = () => {
        router.push({ name: "Programme" })
    }

    const scrollHandler = () => {
        document.getElementById('overview').scrollIntoView({behavior: 'smooth'})
    }

    const openCloseModal = () => {
        emit("watchVideo")
    }


</script>


